import { useSelector } from 'react-redux';
import React from 'react';

import Comments from '../components/Comments';

const Widget = () => {
	const comments = useSelector((state) => state?.comments);

	return comments ? <Comments comments={comments} /> : null;
};

export default Widget;
